<template>
    <div>
        
    </div>
</template>

<script>
export default {
    name: 'FeishuDoc',
    data () {
        return {
            'code': '',
        }
    },
    methods: {
        getCode() {
            this.code = this.$route.query.code
            console.log(this.code)
        }
    },
    mounted () {
        this.getCode()
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/ysy/FeishuDoc.vue